import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import { ContactPageRounded } from '@mui/icons-material';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';

import { useDashboardPage, DashboardPage } from '../../../context/DashboardPageContext';

const mainListItems: { text: string; icon: React.ReactNode; key: DashboardPage }[] = [
  { text: 'Home', icon: <HomeRoundedIcon />, key: 'dashboard' },
  { text: 'Clients', icon: <PeopleRoundedIcon />, key: 'clients' },
  { text: 'Leads (WIP)', icon: <ContactPageRounded />, key: 'leads' },
  { text: 'Tasks (WIP)', icon: <AssignmentRoundedIcon />, key: 'tasks' },
];

const secondaryListItems: { text: string; icon: React.ReactNode; key: DashboardPage }[] = [
  { text: 'Settings', icon: <SettingsRoundedIcon />, key: 'settings' },
  { text: 'About (WIP)', icon: <InfoRoundedIcon />, key: 'about' },
  { text: 'Feedback (WIP)', icon: <HelpRoundedIcon />, key: 'feedback' },
];

export default function MenuContent() {
  const { page, setPage } = useDashboardPage();

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item) => (
          <ListItem key={item.key} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={page === item.key}
              onClick={() => setPage(item.key)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <List dense>
        {secondaryListItems.map((item) => (
          <ListItem key={item.key} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={page === item.key}
              onClick={() => setPage(item.key)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}